import { useState } from "react";

const getQlikBaseUrl = () => {
  const protocol =
    process.env.REACT_APP_IS_SECURE === "true" ? "https" : "http";
  const host = process.env.REACT_APP_HOST;
  return `${protocol}://${host}`;
};

const resolveDownloadUrl = (link) => {
  if (!link) return null;

  const path = typeof link === "object" && link.qUrl ? link.qUrl : link;

  if (typeof path === "string" && path.startsWith("http")) {
    return path;
  }

  return `${getQlikBaseUrl()}${path}`;
};

const downloadFile = async (url, filename) => {
  const response = await fetch(url, { credentials: "include" });
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(blobUrl);
};

export const useExportToXLS = (app) => {
  const [loadingExcel, setLoadingExcel] = useState(false);

  const exportToXLS = async (objectId, exportContainer) => {
    if (!app || !objectId) return;

    setLoadingExcel(true);

    try {
      let id = objectId;

      if (exportContainer) {
        const vis = await app.visualization.get(objectId);
        if (vis?.model?.items?.activeId) {
          id = vis.model.items.activeId;
        }
      }

      const vis = await app.visualization.get(id);

      if (vis?.table?.exportData) {
        const link = await vis.table.exportData({
          format: "OOXML",
          state: "A",
          filename: `export_${id}`,
        });

        const downloadUrl = resolveDownloadUrl(link);
        if (downloadUrl) {
          await downloadFile(downloadUrl, `export_${id}.xlsx`);
          return;
        }
      }

      if (vis?.model?.exportData) {
        const result = await vis.model.exportData(
          "OOXML",
          "/qHyperCubeDef",
          `export_${id}`
        );

        const downloadUrl = resolveDownloadUrl(result);
        if (downloadUrl) {
          await downloadFile(downloadUrl, `export_${id}.xlsx`);
        }
      }
    } catch (error) {
      console.error("Erro ao exportar para XLS:", error);
    } finally {
      setLoadingExcel(false);
    }
  };

  return { exportToXLS, loadingExcel };
};
